/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import ICommonTranslationCollapse from '../../types/common/collapse';

const initTranslationCollapse: ICommonTranslationCollapse = {
    body: '',
    title: '',
};

export default initTranslationCollapse;
